﻿import ExclamationCircle from "@repo/icons/default/ExclamationCircle";
import {
  MessageDrawerRoot,
  MessageDrawerTitle,
  MessageDrawerBody,
  MessageDrawerActions,
  MessageDrawerActionButton,
} from "@/components/ui/drawer/message-drawer";
import { useUnsavedChangesDrawer } from "@/lib/context/unsaved-changes-drawer-context";

import type { JSX } from "react";

export const UnsavedChangesDrawer = (): JSX.Element => {
  const {
    isDrawerVisible,
    closeUnsavedChangesDrawer,
    isSaving,
    handleSaveAndLeave,
    handleLeaveWithoutSaving,
  } = useUnsavedChangesDrawer();

  return (
    <MessageDrawerRoot
      open={isDrawerVisible}
      setOpen={(open) => {
        if (!open) closeUnsavedChangesDrawer();
      }}
      icon={ExclamationCircle}
      variant="secondary"
      dismissible={false}
    >
      <MessageDrawerTitle>Suas alterações não foram salvas!</MessageDrawerTitle>
      <MessageDrawerBody>
        Você tem alterações não salvas. Salve agora para não perder o seu progresso.
      </MessageDrawerBody>
      <MessageDrawerActions>
        <MessageDrawerActionButton
          onClick={() => {
            void handleSaveAndLeave();
          }}
          disabled={isSaving}
        >
          Salvar alterações e sair
        </MessageDrawerActionButton>
        <MessageDrawerActionButton onClick={handleLeaveWithoutSaving} secondary>
          Sair sem salvar
        </MessageDrawerActionButton>
      </MessageDrawerActions>
    </MessageDrawerRoot>
  );
};
